module.exports = __webpack_public_path__ + "static/img/gift11.f878e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/shuang12/gift11.png
// module id = Rf1q
// module chunks = 86